module.exports = __webpack_public_path__ + "img/background-panel-hello.06c27370.svg";